import React, { useEffect, useState } from 'react';
import AdUnit, { useAds } from './AdUnit';

const MobileAdBanner = ({ className = '' }) => {
  const ads = useAds('mobile', 10);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (ads.length <= 1) return undefined;
    const id = setInterval(() => {
      setIndex((i) => (i + 1) % ads.length);
    }, 8000);
    return () => clearInterval(id);
  }, [ads.length]);

  if (!ads.length) return null;

  const current = ads[Math.min(index, ads.length - 1)];

  return (
    <div className={`mobile-ad-wrap ${className}`.trim()}>
      <AdUnit ad={current} variant="mobile" />
      {ads.length > 1 && (
        <div className="mobile-ad-indicators" aria-hidden>
          {ads.map((ad, i) => (
            <button
              key={ad._id}
              type="button"
              className={`mobile-ad-indicator${i === index ? ' is-active' : ''}`}
              onClick={() => setIndex(i)}
              aria-label={`Reklama ${i + 1}`}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default MobileAdBanner;
